<div class="user-box"  [iccMenuTriggerFor]="userBoxMenu" (click)="onMenuToggle(false)" *ngIf="userData">
    <div class="user-box__info">
        <div class="user-box__avatar">
            <img *ngIf="!avatarError" src="{{userData.hostname}}/{{userData.avatar}}" (error)="handleMissingAvatar()" class="logo__img">
            <img *ngIf="avatarError" src="{{userData.hostname}}/img/no-avatar.png" class="logo__img">
        </div>
        <div class="user-box__label">
            <p class="user-box__name">{{userData.userName}}</p>
            <p class="user-box__panel">
                <span
                    *ngIf="isCompanyNameVisible()"
                >{{ maxLength(userData.activeCompanyName,18) }}</span>
            </p>
        </div>
        <button iccIconButton appearance="flat" class="expand-button">
            <icc-icon [name]="menuIsClosed ? 'expand_more' : 'expand_less'" ></icc-icon>
        </button>
    </div>

    <icc-menu
        #userBoxMenu="iccMenu"
        xPosition="before"
        yPosition="below"
        (closed)="onMenuToggle(true)"
    >

        <div class="user-info" #userBoxMenuInfo>
            <ng-container *ngIf="condensedUserMenu">
                <div class="user-info__text" >
                    <div class="user-info__row">
                        <p class="user-info__text__name">{{ maxLength(userData.userName) }}</p>
                        <p
                            *ngIf="isCompanyNameVisible()"
                            class="user-info__text__company"
                        >{{ maxLength(userData.activeCompanyName) }}</p>
                    </div>
                    <div class="user-info__row">
                        <p class="user-info__text__email">{{ maxLength(userData.email) }}</p>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!condensedUserMenu">
                <div class="user-info__text" >
                    <p class="user-info__text__name">{{ maxLength(userData.userName) }}</p>
                    <p class="user-info__text__panel">{{ userData.activePanelName }}</p>
                    <p
                        *ngIf="isCompanyNameVisible()"
                        class="user-info__text__company"
                    >{{ maxLength(userData.activeCompanyName) }}</p>

                    <p class="user-info__text__email">{{ maxLength(userData.email) }}</p>
                </div>
                <div class="user-info__avatar">
                    <div class="user-info__avatar__img">
                        <img *ngIf="!avatarError" src="{{userData.hostname}}/{{userData.avatar}}" (error)="handleMissingAvatar()" class="logo__img">
                        <img *ngIf="avatarError" src="{{userData.hostname}}/img/no-avatar.png" class="logo__img">
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="user-buttons">
            <span *ngIf="userData.activeScope === 'driver'"></span>
            <a iccButton appearance="outline" (click)="onUserSetup()" *ngIf="userData.activeScope !== 'driver' && !disableActions">{{ 'USER|Ustawienia konta' | translate }}</a>
            <a iccButton appearance="primary" href="/iccadmin/default/user/users/logout" *ngIf="userData.activeScope !== 'driver'"> {{ 'USER|Wyloguj' | translate }}</a>
            <a iccButton appearance="primary" (click)="mobileLogout()" *ngIf="userData.activeScope === 'driver'"> {{ 'USER|Wyloguj' | translate }}</a>
        </div>

        <ng-container *ngIf="isMarketSelectVisible() && !disableActions">
            <div class="user-markets">


                    <label iccLabel>{{ 'USER|Rynek:' | translate }}</label>
                    <icc-select
                        (valueChange)="onMarketSelected($event)"
                        (click)="onClickStopPropagation($event)"
                        [value]="userData.activeMarketId"
                        size="small"
                    >
                        <option
                            *ngFor='let market of userData.markets'
                            [value]="market.id"
                            [selected]="market.id == userData.activeMarketId"
                        >
                            {{ maxLength(market.name,22) }}
                        </option>
                    </icc-select>

            </div>
        </ng-container>

        <ng-container *ngIf="isLanguageSelectVisible()">
            <div class="user-languages">


                    <label iccLabel>{{ 'I18N|Język:' | translate }}</label>
                    <icc-select
                        (valueChange)="onLanguageSelected($event)"
                        (click)="onClickStopPropagation($event)"
                        [value]="userData.activeLanguage"
                        size="small"
                    >
                        <option
                            *ngFor='let language of userData.languages'
                            [value]="language.code"
                            [selected]="language.code == userData.activeLanguage"
                        >
                            {{ language.name }}
                        </option>
                    </icc-select>

            </div>
        </ng-container>

        <ng-container *ngIf="(isBasesVisible() || isPriceVersionsVisible()) && !disableActions">

            <div class="user-bases" *ngIf="isBasesVisible()" >

                    <label iccLabel>{{ 'USER|Baza produktowa' | translate }}</label>
                    <icc-select
                        (valueChange)="onBaseSelected($event)"
                        (click)="onClickStopPropagation($event)"
                        [value]="userData.activeProductBaseId"
                        size="small"
                    >
                        <option
                            *ngFor='let productBase of userData.productBases | keyvalue'
                            [value]="productBase.key"
                            [selected]="productBase.key == userData.activeProductBaseId"
                        >
                            {{ maxLength(productBase.value) }}
                        </option>
                    </icc-select>

            </div>
            <div class="user-price-versions" *ngIf="isPriceVersionsVisible()" >

                    <label iccLabel>{{ 'PRICE_VERSION|Wersja cenowa:' | translate }}</label>
                    <icc-select
                        (valueChange)="onPriceVersionSelected($event)"
                        (click)="onClickStopPropagation($event)"
                        [value]="userData.activePriceVersionId"
                        size="small"
                    >
                        <option
                            *ngFor='let priceVersion of userData.priceVersions'
                            [value]="priceVersion.id"
                            [selected]="priceVersion.id == userData.activePriceVersionId"
                            [ngClass]="{'actual': priceVersion.id == userData.actualPriceVersionId}"
                        >
                            <span *ngIf='priceVersion.id == userData.actualPriceVersionId && !stylesSet'>
                                {{ 'PRICE_VERSION|(Aktualna)' | translate }}
                            </span>
                            {{ maxLength(priceVersion.name) }}
                        </option>
                    </icc-select>

            </div>

        </ng-container>

        <div class="user-panels" *ngIf="userData.activeScope !== 'driver' && !disableActions">
            <ng-container *ngFor="let company of userData.panels">
                <p
                    class="user-panels__type"
                    [ngClass]="{'active': panelIsActive(company)}"
                >
                    {{ company.companyName }}
                </p>

                <ng-container *ngFor="let panel of company.panels">
                    <div
                        (click)="onOptionsSelected(panel.panel, panel.companyId)"
                        [ngClass]="{'active': panel.active}"
                    >
                        <icc-icon name="list"></icc-icon>
                        <span>{{ panel.panelName }}</span>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </icc-menu>

</div>
